import { ApiService } from 'react-angle-dashboard-components'
import { IGroupListQueryParams } from './dto'

export class GroupService extends ApiService {
  async getGroupInfo(groupId: string) {
    return this.request({
      method: 'get',
      url: `/groups/${groupId}`,
      credentials: true
    })
  }

  async getBillingGeneralData(groupId: string) {
    return this.request({
      method: 'get',
      url: `/groups/${groupId}`,
      credentials: true
    }).then((r) => ({
      paperlessBilling: r.paperless_billing,
      autopay: r.autopay,
      currentBalanceDue: r.current_balance_due
    }))
  }

  getGroups = (params?: IGroupListQueryParams) => {
    // if (params) {
      // TODO - ENG-2395 - Activate below when pagination is in
      // let url = `/groups?page_number=${params.page_number}&page_limit=${params.page_limit}`
      const baseUrl = `/groups`
      let url = baseUrl

      if (params?.agencyId) {

        // TODO - ENG-2395 - Remove below when pagination is in
        if (url !== baseUrl) {
          url += `&`
        } else {
          url += `?`
        }
        //

        url += `agency_id=${params.agencyId}`
        // url += `&agency_id=${params.agencyId}`
      }

      if (params?.brokerId) {

        // TODO - ENG-2395 - Remove below when pagination is in
        if (url !== baseUrl) {
          url += `&`
        } else {
          url += `?`
        }
        //

        url += `broker_id=${params.brokerId}`
        // url += `&broker_id=${params.brokerId}`
      }

      if (params?.officeId) {

        // TODO - ENG-2395 - Remove below when pagination is in
        if (url !== baseUrl) {
          url += `&`
        } else {
          url += `?`
        }
        //

        url += `office_id=${params.officeId}`
        // url += `&office_id=${params.officeId}`
      }

      return this.request({
        method: 'get',
        url: url,
        credentials: true
      })
    }
}
